module.exports = __webpack_public_path__ + "static/media/garage.ae828940.png";